export default __webpack_public_path__ + "static/media/IMG-20250105-WA0030.ac34dd0a.jpg";